import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Concatène et fusionne des classes Tailwind en gérant correctement les conflits.
 * À utiliser systématiquement dans les composants UI.
 *
 * @example
 * cn('px-2 py-1', condition && 'bg-primary-500', className)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
